<template>
    <div>

        <!-- Featured Class -->
        <div v-if="featuredClass !== null">
            <b-row class="mt-2 mb-2 pointer" @click="gotoFeaturedClass()">
                <b-col cols="4" class="text-center">
                    <b-img fluid v-bind:src="featuredClass.photo" />
                    <div class="text-center completed">FEATURED</div>
                </b-col>
                <b-col cols="8" style="margin-left: -20px;">
                    <div class="class-title">{{featuredClass.className}}</div>
                    <div class="class-details">
                    {{featuredClass.name}}
                    <br>Sponsor: {{featuredClass.companyName}}
                    <br><!-- {{featuredClass.releaseDateUTC | prettyDate}} - -->{{featuredClass.credits}} CEU (Self-Study)
                    </div>
                    <div class="mt-2" v-if="false">
                    <b-button :to="{ path: '/classroom/'+featuredClass.hash }">Enter Classroom</b-button>
                    </div>
                </b-col>
                <b-col cols="12">
                    <div class="mt-2 class-details" style="width:95%;">{{featuredClass.blurb}}</div>
                </b-col>
            </b-row>
        </div>

        <!-- Featured Podcast -->
        <div v-if="featuredPodcast !== null">
            <b-row class="mt-2 mb-2 pointer" @click="gotoFeaturedPodcast()">
                <b-col cols="4" class="text-center">
                    <b-img fluid v-bind:src="featuredPodcast.photo" />
                    <div class="text-center completed">FEATURED</div>
                </b-col>
                <b-col cols="8" style="margin-left: -20px;">
                    <div class="class-title">{{featuredPodcast.title}}</div>
                    <div class="class-details">
                        {{featuredPodcast.speakerName}}
                        <br>Sponsor: {{featuredPodcast.companyName}}
                        <br v-if="featuredPodcast.credits > 0"><!-- {{featuredPodcast.releaseDateUTC | prettyDate}} - --><span v-if="featuredPodcast.credits > 0">{{featuredPodcast.credits}} CEU (Self Study)</span>
                        <br><b-icon icon="clock"></b-icon>&nbsp;{{featuredPodcast.durationSec | prettySeconds}}
                    </div>
                </b-col>
            </b-row>
        </div>

        <!-- Featured Blog Post -->
        <div v-if="featuredBlog !== null">
            <b-row class="mt-2 mb-2 pointer" @click="gotoFeaturedBlogPost()">
                <b-col cols="12">
                  <div class="class-title">
                    <b-icon icon="caret-right-fill"></b-icon> <span v-if="featuredBlog.featured" class="txt-blog-featured">Featured</span>{{ featuredBlog.title }}
                  </div>
                  <div class="class-details">
                    {{ featuredBlog.blurb }}
                  </div>
                </b-col>
            </b-row>
        </div>

    </div>
</template>

<script>
/* eslint-disable */

'use strict'

import service from "@/service/service"
import utils from "@/utils/utils"
import constants from "@/config/constants"

export default {
    name: "VpFeaturedContent",
    data() {
        return {
            debug: false,
            error: false,
            errorMsg: '',
            busy: true,
            submitted: false,
            studentHash: this.$root.getToken(),
            featuredClass: null,
            featuredPodcast: null,
            featuredBlog: null,
            featuredHash: null,
        }
    },
    props: {
        fc: {   // featured class
            type: Object,
            default: null
        },
        fp: {   // featured podcast
            type: Object,
            default: null
        },
        fb: {   // featured blog
            type: Object,
            default: null
        },
        fh: {   // VpAdFeaturedContent.hash
            type: String,
            default: null
        }
    },
    computed: {

    },
    methods: {
        gotoClass(hash) {
            this.$router.push(`/classroom/${hash}`)
        },
        gotoPodcast(ps,p) {  // podcastShowHash, podcastHash
            this.$router.push(`/podcast/${ps}/${p}`)
        },
        gotoBlogPost(blogId) {
            this.$router.push(`/blog-post/${blogId}`)
        },
        gotoFeaturedClass() {
            this.busy = true
            service
                .logFeaturedContentClick(this.studentHash, constants.VPAD_SLOT_TYPE.VPAD_FEATURED_CLASS, this.featuredHash)
                .then(res => {
                    if (this.debug) console.log(res);
                    if (!res.status) {
                        console.log('Error Class! logFeaturedContentClick()')
                    }
                })
                .finally(() => {
                    this.busy = false
                    this.gotoClass(this.featuredClass.hash)
                })
                .catch(e => console.log(e))
        },
        gotoFeaturedPodcast() {  // podcastShowHash, podcastHash
            this.busy = true
            service
                .logFeaturedContentClick(this.studentHash, constants.VPAD_SLOT_TYPE.VPAD_FEATURED_PODCAST, this.featuredHash)
                .then(res => {
                    if (this.debug) console.log(res);
                    if (!res.status) {
                        console.log('Error Podcast! logFeaturedContentClick()')
                    }
                })
                .finally(() => {
                    this.busy = false
                    this.gotoPodcast(this.featuredPodcast.podcastShowHash, this.featuredPodcast.hash)
                })
                .catch(e => console.log(e))
        },
        gotoFeaturedBlogPost() {
            this.busy = true
            service
                .logFeaturedContentClick(this.studentHash, constants.VPAD_SLOT_TYPE.VPAD_FEATURED_BLOG, this.featuredHash)
                .then(res => {
                    if (this.debug) console.log(res);
                    if (!res.status) {
                        console.log('Error Blog! logFeaturedContentClick()')
                    }
                })
                .finally(() => {
                    this.busy = false
                    this.gotoBlogPost(this.featuredBlog.id)
                })
                .catch(e => console.log(e))
        },
    },
    created() {
        // console.log(this.mb)
        this.featuredClass = this.fc || null
        this.featuredPodcast = this.fp || null
        this.featuredBlog = this.fb || null
        this.featuredHash = this.fh || null
        console.log(`vpfeaturedcontent  hash: ${this.featuredHash}`)
    },
    mounted() {
        // console.log('vpfeaturedcontent mounted')
    },
    beforeDestroy() {
        // console.log('vpfeaturedcontent beforeDestroy')
    }
}
</script>


<style scoped>


</style>




// WEBPACK FOOTER //
// src/components/VpFeaturedContent.vue